import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = [
  {
    title: 'For Workers',
    links: [
    { label: 'Find Work', path: '/job-board' },
    { label: 'Create Profile', path: '/user-dashboard' },
    { label: 'How It Works', path: '/home-landing' },
    { label: 'Success Stories', path: '/home-landing' }]

  },
  {
    title: 'For Clients',
    links: [
    { label: 'Post a Job', path: '/post-job' },
    { label: 'Browse Workers', path: '/job-board' },
    { label: 'Pricing', path: '/home-landing' },
    { label: 'Safety Tips', path: '/home-landing' }]

  },
  {
    title: 'Company',
    links: [
    { label: 'About Us', path: '/home-landing' },
    { label: 'Contact', path: '/home-landing' },
    { label: 'Careers', path: '/home-landing' },
    { label: 'Press', path: '/home-landing' }]

  },
  {
    title: 'Support',
    links: [
    { label: 'Help Center', path: '/home-landing' },
    { label: 'Terms of Service', path: '/home-landing' },
    { label: 'Privacy Policy', path: '/home-landing' },
    { label: 'Trust & Safety', path: '/home-landing' }]

  }];


  const socialLinks = [
  { icon: 'Facebook', label: 'Facebook', url: '#' },
  { icon: 'Twitter', label: 'Twitter', url: '#' },
  { icon: 'Instagram', label: 'Instagram', url: '#' },
  { icon: 'Linkedin', label: 'LinkedIn', url: '#' }];


  return (
    <footer className="border-t border-border bg-[#1F2937]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-4 md:py-5 bg-[#1F2937]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-4">
          {/* Left Column - Brand Info */}
          <div>
            <Link to="/home-landing" className="inline-flex items-center gap-2 mb-2">
              <img 
                src="/assets/images/LOGO-1771655664486.png" 
                alt="DISKARTE Logo" 
                className="w-8 h-8 object-contain"
              />
              <span className="text-base font-heading font-bold text-white">
                DISKARTE
              </span>
            </Link>
            <p className="text-[10px] mb-2 max-w-[400px] text-white/90 leading-relaxed">
              Connecting Filipino service providers with clients through verified profiles and trusted interactions. Your partner in the gig economy.
            </p>
            <div className="flex items-center gap-1.5">
              {socialLinks?.map((social) =>
              <a
                key={social?.label}
                href={social?.url}
                aria-label={social?.label}
                className="w-7 h-7 bg-white/10 hover:bg-[#FF6A00] rounded-lg flex items-center justify-center transition-smooth group">

                  <Icon
                  name={social?.icon}
                  size={14}
                  className="text-white transition-smooth" />

                </a>
              )}
            </div>
          </div>

          {/* Right Column - All Footer Sections */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
            {footerSections?.map((section) =>
            <div key={section?.title}>
                <h3 className="text-[11px] font-heading font-semibold mb-1.5 text-[#FF6A00]">
                  {section?.title}
                </h3>
                <ul className="space-y-1">
                  {section?.links?.map((link) =>
                <li key={link?.label}>
                      <Link
                    to={link?.path}
                    className="text-[10px] hover:text-[#FF6A00] transition-smooth text-white/90">

                        {link?.label}
                      </Link>
                    </li>
                )}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="pt-3 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-1.5 bg-[#1F2937]">
            <div className="text-[10px] text-white/70 text-center md:text-left">
              © {currentYear} DISKARTE. All rights reserved.
            </div>
            <div className="flex items-center gap-2">
              <Link
                to="/home-landing"
                className="text-[10px] hover:text-[#FF6A00] transition-smooth text-white/90">

                Terms
              </Link>
              <Link
                to="/home-landing"
                className="text-[10px] hover:text-[#FF6A00] transition-smooth text-white/90">

                Privacy
              </Link>
              <Link
                to="/home-landing"
                className="text-[10px] hover:text-[#FF6A00] transition-smooth text-white/90">

                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;